<template>
    <div class="module">
        <a href="javascript:void(0)" class="scrollT" ref="module"></a>
        <div class="banner">
            <div class="main">
                <div class="title">Authenticité des modules <br>DMEGC SOLAR</div>
            </div>
        </div>
        <div class="box">
            <div class="search wow fadeInUp">
                <input type="text" v-model="cptm" placeholder="Saisir le numéro de série ici" class="text">
                <button class="btn" @click="searchCode"></button>
            </div>
            <div class="result-main">
                <a href="javascript:void(0);" class="anchor" ref="result"></a>
                <div class="result wow fadeInUp" v-if="resultFlag === 1">
                    <div class="title">Informations sur le produit：</div>
                    <div class="list">
                        <div class="item">
                            <div class="name">Code-barres du produit</div>
                            <div class="num">{{infoData.cptm}}</div>
                        </div>
                        <div class="item">
                            <div class="name">Modèle du produit</div>
                            <div class="num">{{infoData.cpxh}}</div>
                        </div>
                        <div class="item">
                            <div class="name">Puissance du produit</div>
                            <div class="num">{{infoData.cpgl}}</div>
                        </div>
                        <div class="item">
                            <div class="name">Grade du produit</div>
                            <div class="num">{{infoData.cpdjen}}</div>
                        </div>
                    </div>
                </div>
                <div class="no-result wow fadeInUp" v-if="resultFlag === 2">
                    <div class="title">Informations sur le produit：</div>
                    <div class="icon"></div>
                    <h4>Désolé, l'information sur le module que vous avez demandée n'a pas été trouvée.</h4>
                    <div class="txt">
                        1. Le numéro de série que vous vérifiez est incorrect. <br>
                        2. Le numéro de série que vous vérifiez n'est pas un produit DMEGC Solar., <br>
                        3. Le numéro de série que vous vérifiez doit commencer par DM******. <br>
                        4. Le module produit après le 1er janvier 2024 est disponible dans ce système. <br>
                        En cas de questions, veuillez contacter votre distributeur ou l'équipe du service client de DMEGC Solar par hotline : +86-579-86310330 ou service@dmegc.com.cn pour obtenir de l'aide.

                    </div>
                    <div class="tips">Pour plus d'informations, veuillez contacter l'équipe de service de DMEGC Solar.</div>
                    <a href="javascript:void" @click="resetSearch">Retour<i></i></a>
                </div>
            </div>
            <div class="info wow fadeInUp">
                Le numéro de série est unique pour chaque module et se compose de <br>
                chiffres et d'alphabets, comme dans l'exemple ci-dessous.
            </div>
            <div class="tel wow fadeInUp">
                Pour toute question, veuillez contacter l'équipe de service de DMEGC au numéro suivant<br>
                <span>+ 86-579-86310330 (jours ouvrables 8:30 17:00)</span> ou <span>service@dmegc.com.cn</span>
            </div>
            <div class="title wow fadeInUp">Exemple de schéma du nméro de série：</div>
            <div class="pic wow fadeInUp">
                <img src="../../assets/img/query_pic.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    import { WOW } from 'wowjs'
    import { queryCompoments } from '../../request/api'
    export default {
        name:'Module',
        metaInfo:{
            title: "Authenticité des modules-DMEGC Solar",
            meta: [{                 // set meta
                name: 'keyWords',
                content: 'DMEGC Solar,Énergie renouvelable'
                }, {
                name: 'description',
                content: 'Premier fournisseur mondial dénergie renouvelable'
            }]
        },
        data(){
            return {
                cptm:'',
                infoData:{},
                msg:'',
                resultFlag: 0,
                isMobile:false
            }
        },
        mounted(){
            this.$nextTick(() => {

                const wow = new WOW({
                    animateClass: 'animated',
                    offset: 100
                })
                wow.init();
                this.$refs.module.scrollIntoView();
            })
        },
        methods: {
            searchCode(){

                if(this.cptm === '') {

                    alert('Saisir le numéro de série ici')
                } else {

                    queryCompoments({cptm: this.cptm}).then(res => {
            
                        if(res.code == '00000000') {

                            this.resultFlag = 1
                            this.infoData = res.data
                            this.cptm = ''
                        } else {
                            this.resultFlag = 2
                            this.msg = res.msg
                            this.cptm = ''
                        }

                        //this.$refs.result.scrollIntoView({behavior: "smooth"});
                    })
                }
            },
            resetSearch(){

                this.cptm = ''
                this.resultFlag = 0
                this.$refs.module.scrollIntoView({behavior:'smooth'});
            }
        }
    }
</script>

<style lang="scss" scoped>
.module{
    position: relative;
    .banner{
        height: 27.0833vw;
        background: url(../../assets/img/module_banner.jpg) no-repeat center center;
        background-size: cover;
        .main{
            height: 27.0833vw;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .title{
            font-size: 2.7083vw;
            line-height: 1.1154;
            color: #fff;
            text-align: center;
            font-weight: 300;
        }
    }
    .box{
        margin: -36px auto 0;
        width: 1124px;
        position: relative;
        z-index: 10;
        padding-bottom: 110px;
    }
    .search{
        display: flex;
        justify-content: space-between;
        .text{
            display: block;
            box-sizing: border-box;
            width: calc(100% - 82px);
            height: 72px;
            background: #F2F4F8;
            border: none;
            padding: 0 40px;
            font-size: 20px;
            color: #A4AAB6;
        }
        .btn{
            display: block;
            width: 82px;
            height: 72px;
            border: none;
            background: url(../../assets/images/search_w.png) no-repeat center center #E60011;
            background-size: 26px 26px;
        }
    }
    .info{
        text-align: center;
        font-size: 20px;
        line-height: 1.5;
        color: rgba(0, 0, 0, 0.8);
        margin-top: 30px;
    }
    .tel{
        text-align: center;
        margin: 27px 0 40px;
        font-size: 20px;
        line-height: 1.5;
        color: rgba(0, 0, 0, 0.8);
        span{
            color: #E60011;
            font-weight: bold;
        }
    }
    .title{
        font-size: 25px;
        line-height: 1.92;
        text-align: center;
        color: #000;
    }
    .pic{
        width: 451px;
        margin: 6px auto 0;
        img{
            display: block;
            width: 100%;
        }

    }
    .result-main{
        position: relative;
        margin: 30px 0 68px;
    }
    .result{
        border-bottom: 1px solid #E1E6EF;
        padding-bottom: 35px;
        .title{
            text-align: left;
        }
        .list{
            margin-top: 12px;
        }
        .item{
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 90px;
            background: #F2F4F8;
            margin-bottom: 10px;
            font-size: 18px;
            color: rgba(31, 50, 67, 0.7);
            padding: 0 40px;
            line-height: 1.4;
        }
        .num{
            color: #1F3243;
            text-align: right;
            max-width: 400px;
        }
    }
    .no-result{
        border-bottom: 1px solid #E1E6EF;
        padding-bottom: 35px;
        .icon{
            width: 56px;
            height: 56px;
            background: url(../../assets/images/close.png) no-repeat center center #FF0000;
            background-size: 20px 20px;
            border-radius: 50%;
            margin: 30px auto 0;
        }
        h4{
            font-size: 25px;
            line-height: 1.92;
            color: #E60011;
            text-align: center;
            margin-top: 8px
        }
        .txt{
            font-size: 20px;
            line-height: 1.6;
            color: rgba(0, 0, 0, 0.6);
            margin: 48px auto 0;
            width: 685px;
        }
        .tips{
            font-size: 25px;
            line-height: 1.92;
            color: #000000;
            text-align: center;
            margin-top: 48px;
        }
        a{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 260px;
            height: 50px;
            box-sizing: border-box;
            padding: 0 30px;
            font-size: 16px;
            color: #fff;
            background: #E60011;
            margin: 52px auto 0;
        }
        i{
            display: block;
            width: 24px;
            height: 24px;
            background: url(../../assets/images/arrowR.png) no-repeat;
            background-size: cover;
        }
    }
}
@media screen and (max-width: 750px) {
    .module{
        .banner{
            height: 5rem;
        }
        .box{
            width: 92%;
            padding-bottom: .8rem;
            margin-top: -.5rem;
        }
        .search{
            .text{
                width: calc(100% - 1.2rem);
                height: 1rem;
                padding: 0 .3rem;
                font-size: .28rem;
            }
            .btn{
                width: 1.2rem;
                height: 1rem;
                background-size: .52rem .52rem;
            }
        }
        .info{
            font-size: .28rem;
            margin-top: .6rem;
        }
        .tel{
            font-size: .28rem;
            margin: .4rem 0 .6rem;
        }
        .title{
            font-size: .36rem;
        }
        .pic{
            width: 4.5rem;
            margin-top: .2rem;
        }
        .result-main{
            margin: .4rem 0 .8rem;
        }
        .result{
            padding-bottom: .6rem;
            .list{
                margin-top: .2rem;
            }
            .item{
                height: 1rem;
                margin-bottom: .2rem;
                padding: 0 .3rem;
                font-size: .28rem;
            }
            .num{
                max-width: 4rem;
            }
        }
        .no-result{
            padding-bottom: .6rem;
            .icon{
                width: 1.12rem;
                height: 1.12rem;
                background-size: .4rem .4rem;
                margin-top: .6rem;
            }
            h4{
                font-size: .36rem;
                margin-top: .3rem;
            }
            .txt,.tips{
                font-size: .28rem;
                width: 100%;
                margin-top: .6rem;
            }
            a{
                width: 4.2rem;
                height: .8rem;
                font-size: .3rem;
                padding: 0 .6rem;
                margin-top: .6rem;
            }
            i{
                width: .48rem;
                height: .48rem;
            }
        }
    }
}
</style>